/* global dwolla  */
import path from 'path';
export function getDwollaTokenFromUI(IAVToken, containerId, fullscreen, setFullScreen, callback) {
  try {
    dwolla.iav.start(IAVToken, {
      stylesheets: [
        'https://codepen.io/royalsix/pen/mdJzZQG.css',
        'https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext',
        `${process.env.GATSBY_BASE_URL}give.css`,
      ],
      microDeposits: false,
      fallbackToMicroDeposits: false,
      backButton: true,
      container: containerId,
      subscriber: ({ currentPage, error }) => {
        if (currentPage === 'BankLogin' && !fullscreen) {
          setFullScreen(true);
        }

        if (error || currentPage === 'BankSearch' || currentPage === 'SuccessIAV') {
          setFullScreen(false);
        }
      },
    }, function (err, res) {
      if (err) {
        console.error(err);
      } else {
        const { _links: { 'funding-source': { href } } } = res;

        if (href) {
          callback({ achToken: path.basename(href), processorType: 'dwolla' });
        }
      }
    });
  } catch (err) {
    console.warn(err);
  }
}